<template>
<div class="form-elements">
        <div class="row" v-show="!download.load">
            <div class="form-group">
                <div class="col-md-6">
                    <input type="date" id='dia-inicio'>
                </div>
                <div class="col-md-6">
                    <input type="date" id='dia-fim'>
                </div>
            </div>
            <div class="form-group">
                <div class="col-md-12">
                    <button @click="getDoacoes()" class="btn btn-primary btn-micro">Gerar Relatório</button>
                </div>
            </div>
        </div>
        <div v-show="download.load">
            <span>Pode demorar um pouco...</span>
            <div class="d-flex justify-content-center">
                <div class="btn-toolbar  d-inline-flex" role="toolbar" aria-label="Toolbar with button groups">
                    <component :animation-duration="1000" :is="'SpringSpinner'" :color="'#4AE387'" :size="80"></component>
                </div>
            </div>
        </div>
</div>
</template>

<script>
	import * as spinners from "epic-spinners"
    import urlApi from '../../../../router/urlApi'
    
export default {
    name: "relatorioDoacoes",
    components: {
        ...spinners,
    },
    data() {
        return {
            download:{
                load: false
            },
        }
    },
    methods: {
        getDoacoes(){
            this.download.load = true;
            let diaI = document.getElementById('dia-inicio').value;
            let diaF = document.getElementById('dia-fim').value;
            this.$http.get(urlApi+'/pdf/autoescolas/aulas/praticas/'+diaI+'/'+diaF)
            .then(this.downloadPDF)
        },
        downloadPDF(response){
            if(response.data.dados){
                let code64 = response.data.dados;
                var pdf = 'data:application/octet-stream;base64,' + code64;

                var dlnk = document.getElementById('downloadPDF');
                dlnk.download="novoCFC.pdf";
                dlnk.href = pdf;
                dlnk.click();
                this.download.load = false;
            }else{
                this.$toasted.show('Consulta não possui resultado', {
                    position: 'top-right',
                })
                this.download.load = false;
            }
        },
    },
}
</script>

<style>

</style>